
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'

import {wxShareConfig} from '../js/common/utils'
import configInfo from "../configInfo.js"
export default {
props: {



},
data () {
return {
currentPage:null,
league: {},
bestTeamNameLength: 10,
leagueId: this.$route.query.leagueId,
eventHub: this.$store.getters.getEventHub,
leagueBasicInfo: this.$store.getters.getLeagueBasicInfo
}
},
mounted(){
if (this.eventHub) {
this.eventHub.$on('loadMoreData', () => {
this.loadMore();
})
this.eventHub.$on('refreshTabData', () => {
this.refreshTab();
})
}
this.initTab();




this.$nextTick(() => {
var width = document.body.clientWidth;
if (width < 360) {
this.bestTeamNameLength = 10;
} else {
this.bestTeamNameLength = 15;
}
})




},
components: {
Tab,
TabItem,
Scroller,
Divider,
XSwitch,
Group,
Spinner,
ButtonTab,
ButtonTabItem,
Flexbox,
FlexboxItem
},
beforeRouteLeave (to, from, next) {
if(this.currentPage){

}
next();
},
methods: {
initWxShareConfig:function(){
this.currentPage = window.location.href;
var fullPath = window.location.href;


var shareImg = window.location.origin + configInfo.routerBase + "static/logo.png";
if (this.leagueBasicInfo.league_logo) {
shareImg = this.hagkApi.getImgAssetById(this.leagueBasicInfo.league_logo).url;
}
console.log(fullPath)


wxShareConfig({
title: this.leagueBasicInfo.title+'-战术数据',
desc: "来自未来足球赛事系统",
link: fullPath,
imgUrl: shareImg,
type: 'link',
dataUrl: ''
}, () => {
console.log("share success")
}, () => {
console.log("share error")
});
},
initTab(){
this.eventHub.$emit("setTabIndex", "leagueData");
this.initWxShareConfig();
var leagueId = parseInt(this.leagueId);
if (!this.league.statistic) {
this.$vux.loading.show({
text: '加载中...'
})
this.loadData(leagueId, () => {
this.$vux.loading.hide()
})
}
},
loadData(leageId, afterCall){
this.hagkHttp(this.hagkApi.getLeagueData(leageId), {})
.then((res) => {
if (res.status == true) {
this.league = res.result;
if (res.result) {
this.getBest();
}
}
}, (error) => {
console.log(error);
});
afterCall();
},
refreshTab(){
var leagueId = parseInt(this.leagueId)
this.loadData(leagueId, () => {
this.eventHub.$emit("enablerefreshTab")
})
},
loadMore(){
this.eventHub.$emit("enableloadMore");
},
getBest: function () {
var scoreBoard = [];
if (this.league.scoreBoard) {
scoreBoard = this.league.scoreBoard;
}
var bestGoalFor;
var bestGoalAgainst;
var maxAvgGoal = 0;
var minAvgLoss = 9999;
for (var i = 0; i < scoreBoard.length; i++) {
if (0 == scoreBoard[i].matchNum) {
continue;
}

var tempAvgGoal = (scoreBoard[i].goal / scoreBoard[i].matchNum).toFixed(2);
if (tempAvgGoal > maxAvgGoal) {
maxAvgGoal = tempAvgGoal;
bestGoalFor = scoreBoard[i];
}

var tempAvgLoss = (scoreBoard[i].loss / scoreBoard[i].matchNum).toFixed(2);
if (tempAvgLoss < minAvgLoss) {
minAvgLoss = tempAvgLoss;
bestGoalAgainst = scoreBoard[i];
}
}
if (maxAvgGoal > 0) {
this.league.bestGoalFor = bestGoalFor;
}
if (minAvgLoss < 9999) {
this.league.bestGoalAgainst = bestGoalAgainst;
}
}
},
filters: {
subfilter: function (value, sublength) {
if (!value) return ''
value = value.toString()
if (value.length > sublength) {
return value.substr(0, sublength) + "...";
}
return value;
}
}
}



// WEBPACK FOOTER //
// ./src/views/leagueData.vue